<div class="workflow-recipe-card-plugin" hive-root>
    <svg class="workflow-recipe-card-plugin__icon" [hive-svg]="signalIcon()" [width]="24" [height]="24"></svg>

    <ul class="workflow-recipe-card-plugin__list">
        @for (recipe of visibleRecipes(); track $index) {
            <li class="workflow-recipe-card-plugin__recipe">
                <hive-label
                    class="workflow-recipe-card-plugin__title"
                    [label]="recipe.title || 'Untitled recipe'"
                    size="large"
                    weight="semibold"
                ></hive-label>

                <hr class="workflow-recipe-card-plugin__divider" />

                @if (recipe.description) {
                    <hive-label
                        class="workflow-recipe-card-plugin__description"
                        [label]="recipe.description"
                        size="small"
                    ></hive-label>
                }
                <!-- `workatoConnectorIds` is parsed onto the model but not shown on the tile,
                     which is a summary: they are raw Workato ids, and the display names come from
                     the catalog detail the dialog fetches and this plugin does not. -->
            </li>
        }
    </ul>

    @if (hiddenRecipeCount() > 0) {
        <!-- The card is clickable end to end, so this needs no handler of its own; it
             does need to say where the rest are, being the only sign that they exist. -->
        <span class="workflow-recipe-card-plugin__overflow"> +{{ hiddenRecipeCount() }} more — open for details </span>
    }
</div>
